import Hero from "../../components/hero-section/Hero";
import HomePageProductsSlider from "../../components/home-page-product-slider/HomePageProductsSlider";
import WhatAreYouLookingFor from "../../components/what-are-you-looking-for/WhatAreYouLookingFor";
import GramSection from "../../components/gram-section/GramSection";
import FAQSlider from "../../components/faq/FAQSlider";
import AboutUs from "../../components/about/AboutUs";
import { useEffect } from "react";
import "./Home.css";

import {
  bestSellingProducts,
  whatsHotRightNow,
  sampleGramVideos,
  mostLovedproducts,
  youCannotMissThis,
} from "../../constants/ProductConstants";

export default function Home({ addToCart }) {
  useEffect(() => {
    const sections = document.querySelectorAll('.fade-section');
    if (!('IntersectionObserver' in window)) {
      // fallback: reveal all
      sections.forEach(s => s.classList.add('in-view'));
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    sections.forEach(s => io.observe(s));
    return () => io.disconnect();
  }, []);

  return (
    <div style={styles.page}>
      
      {/* HERO */}
      <section className="fade-section" style={styles.heroSection}>
        <Hero />
      </section>

      {/* CATEGORIES */}
      <section className="fade-section" style={styles.section}>
        <div style={styles.container}>
          <WhatAreYouLookingFor />
        </div>
      </section>

      {/* BEST SELLERS */}
      <section className="fade-section" style={styles.section}>
        <div style={styles.container}>
          <HomePageProductsSlider
            addToCart={addToCart}
            products={mostLovedproducts}
            title={"Most Loved ✨"}
          />
        </div>
      </section>

      <section className="fade-section" style={styles.section}>
        <div style={styles.container}>
          <HomePageProductsSlider
            addToCart={addToCart}
            products={whatsHotRightNow}
            title={"What’s hot right now 🔥"}
          />
        </div>
      </section>

      {/* You Cannot Miss This */}
      <section className="fade-section" style={styles.section}>
        <div style={styles.container}>
          <HomePageProductsSlider
            addToCart={addToCart}
            products={youCannotMissThis}
            title={"You Cannot Miss This 👀"}
          />
        </div>
      </section>

      {/* SOCIAL PROOF */}
      <section className="fade-section" style={styles.section}>
        <div style={styles.container}>
          <GramSection videos={sampleGramVideos} />
        </div>
      </section>

      {/* FAQ */}
      <section className="fade-section" style={{ ...styles.section, ...styles.faqSection }}>
        <div style={styles.container}>
          <FAQSlider />
        </div>
      </section>

      {/* ABOUT */}
      <section className="fade-section" style={styles.section}>
        <div style={styles.container}>
          <AboutUs />
        </div>
      </section>

      

    </div>
  );
}

const styles = {
  page: {
    background: "#FFF8F5",
  },

  heroSection: {
    margin: "0 0 40px 0",
  },

  section: {
    margin: "72px 0",
  },

  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 16px",
    boxSizing: "border-box",
  },

  trustSection: {
    margin: "24px 0 0 0",
  },

  trustContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "24px",
    fontSize: "14px",
    color: "#555",
    flexWrap: "wrap",
    padding: "0 16px",
  },

  faqSection: {
    // paddingBottom: "80px",
  },
};